import { useQuery } from "@tanstack/react-query";
import { ActivityKeys } from "web_myplann/Api/Activities/ActivityKeys";
import { getActivityV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useActivityListQuery = (
	filterDatefrom?: string,
	filterDateto?: string,
	filterOnlyunsolved?: boolean,
	filterOnlysolved?: boolean,
	limit?: number,
	offset?: number,
) => {
	return useQuery({
		queryKey: ActivityKeys.list(
			filterDatefrom,
			filterDateto,
			filterOnlyunsolved,
			filterOnlysolved,
			limit,
			offset,
		),
		queryFn: processResponse(() =>
			getActivityV2(
				filterDatefrom,
				filterDateto,
				filterOnlyunsolved,
				filterOnlysolved,
				limit,
				offset,
			),
		),
	});
};
